import { render, staticRenderFns } from "./downloadTool.vue?vue&type=template&id=60b0b60a&scoped=true&"
import script from "./downloadTool.vue?vue&type=script&lang=js&"
export * from "./downloadTool.vue?vue&type=script&lang=js&"
import style0 from "./downloadTool.vue?vue&type=style&index=0&id=60b0b60a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0b60a",
  null
  
)

component.options.__file = "downloadTool.vue"
export default component.exports